import jQuery from 'jquery';
import jQueryUi from 'jquery-ui';
import _ from 'underscore';
import _String from 'underscore.string';

jQuery.widget('ep.messages', {
	options: {
		timerInterval: 50,
		classes: {
			widget: 'messages-widget',
			empty: 'messages-widget-empty',
			message: 'messages-widget-message',
			typePrefix: 'messages-widget-type-',
			hintPrefix: 'messages-widget-hint-'
		},
		expireTime: 10000,
		limit: false
	},
	_create: function(){
		this._setUpState();
		this._setUpDom();
		this._loadDataFromDom();
		this._setUpListeners();
	},
	_setUpState: function(){
		this._messages = [];
	},
	_setUpDom: function(){
		this.element.addClass(this.options.classes.widget + ' ' + this.options.classes.empty);
	},
	_loadDataFromDom: function(){
		const widget = this;
		const typePrefix = widget.options.classes.typePrefix;
		
		this.element.find('.messages-widget-message')
		.each(function(idx, item){
			const domElm = jQuery(item);
			const message = domElm.html();
			
			let type = 'info';
			const classes = domElm.attr('class').split(' ');
			for(let i = 0; i < classes.length; i++){
				const classStr = classes[i];
				if(_String.startsWith(classStr, typePrefix)){
					type = classStr.substring(typePrefix.length, classStr.length);
					break;
				}
			}
			
			widget.addMessage({
				text: message,
				type: type
			}, domElm);
		});
	},
	_setUpListeners: function(){
		const body = jQuery('body');
		
		this._on(body, {
			message: '_onMessage',
			clearmessages: '_onClearMessages'
		});
	},
	_startTimer: function(){
		if(typeof this._intervalId === 'undefined' && this._messages.length !==0){
			this._intervalId = setInterval(this._onInterval.bind(this), this.options.timerInterval);
		}
	},
	_onInterval: function(){
		this._expireMessages();
		this._removeDeletedMessages();
		
		if(this._messages.length === 0){
			clearInterval(this._intervalId);
			this._intervalId = undefined;
		}
	},
	_expireMessages: function(){
		const widget = this;
		this._markMessagesAsDeleted(function(message){
			return widget._isMessageExpired.apply(widget, [message.message])
		});
		
	},
	_markMessagesAsDeleted: function(shouldMarkAsDeletedFunc){
		const widget = this;
		this._messages.forEach(function(message){
			if(shouldMarkAsDeletedFunc(message)){
				message.deleted = true;
			}
		});
	},
	_removeDeletedMessages: function(){
		const nonDeletedMessages = [];
		const deletedMessages = [];
		this._messages.forEach(function(message){
			if(!message.deleted){
				nonDeletedMessages.push(message);
			}else{
				deletedMessages.push(message);
			}
		});
		
		//Remove messages
		deletedMessages.forEach(function(message){
			message.domElm.remove();
		});
		
		if(nonDeletedMessages.length === 0){
			this.element.addClass(this.options.classes.empty);
		}
		
		this._messages = nonDeletedMessages;
	},
	_isMessageExpired: function(message){
		const now = new Date();
		
		return (message.expires !== false && now.getTime() >= message.expires.getTime());
	},
	_onMessage: function(event, message){
		this.addMessage(message);
	},
	addMessage: function(message, existentDomElm){
		if(typeof message.expires === 'undefined'){
			message.expires = this._createDefaultExpireDate();
		}
		
		if(!this._isMessageExpired(message)){
			//Check limit
			if(this.options.limit !== false && this.options.limit < (this._messages.length + 1)){
				const remainder = this._messages.length + 1 - this.options.limit;
				for(let i = 0; i < remainder; i++){
					this._messages[i].deleted = true;
				}
				
				this._removeDeletedMessages();
			}
			
			//Add new message
			let domElm = existentDomElm;
			if(typeof existentDomElm === 'undefined'){
				domElm = this._createMessageDomElm(message);
				this.element.append(domElm);
			}
			
			this._messages.push({
				domElm: domElm,
				message: message,
				deleted: false,
			});
			
			this.element.removeClass(this.options.classes.empty);
			
			this._startTimer();
		}
	},
	_createDefaultExpireDate: function(){
		const date = new Date();
		date.setTime(date.getTime() + this.options.expireTime);
		
		return date;
	},
	_createMessageDomElm: function(message){
		const options = this.options;
		
		const elm = jQuery('<div/>');
		elm.addClass(options.classes.message +' ' + options.classes.typePrefix + message.type);
		if(typeof message.hint !== 'undefined'){
			if(jQuery.isArray(message.hint)){
				message.hint.forEach(function(currHint){
					elm.addClass(options.classes.hintPrefix + currHint);
				});
			}else{
				elm.addClass(options.classes.hintPrefix + message.hint);
			}
		}
		elm.append(jQuery('<div>' + message.text + '</div>'));
		
		return elm;
	},
	_onClearMessages: function(event, data){
		this.clearMessages(data.hint);
	},
	clearMessages: function(hint){
		const hasHint = typeof hint !== undefined;
		
		this._markMessagesAsDeleted(function(message){
			let markAsDeleted = false;
			
			const msgHint = message.message.hint;
			const hasMsgHint = typeof msgHint !== undefined;
			if(hasHint){
				if(hasMsgHint){
					markAsDeleted = _.isEqual(hint, msgHint);
				}
			}else{
				markAsDeleted = true;
			}
			
			return markAsDeleted;
		});
	}
});

let defaultRun = false;
export default function(){
	if(!defaultRun){
		jQuery(function(){
			const widgets = jQuery('[data-messages-widget]');
			widgets.each(function(){
				const widget = jQuery(this);
				widget.wrap('<div aria-live="assertive"></div>');
				
				const opts = {};
				const limit = widget.data('limit');
				if(typeof limit !== 'undefined'){
					opts.limit = limit;
				}
				
				widget.messages(opts);
			});
		});
		
		defaultRun = true;
	}
}